import {configureStore} from '@reduxjs/toolkit'
import {TypedUseSelectorHook, useDispatch, useSelector} from 'react-redux'
import { authSlice } from './auth';
import { userSlice } from './users';
import { listingSlice } from './listings';
import { BookingSlice } from './bookings';
import { messageSlice } from './listings/messageSlice';
import { utilSLice } from './utils';
import { WalletSlice } from './wallet';
import LocationProfileSlice from './location-profile';
import { notificationSlice } from './notifications';
import { AdminSlice } from './admin';




 export const store = configureStore({
    reducer:{
        auth:authSlice.reducer,
        user:userSlice.reducer,
        admin:AdminSlice.reducer,
        utils:utilSLice.reducer,
        chats:messageSlice.reducer,
        wallet:WalletSlice.reducer,
        booking:BookingSlice.reducer,
        listing:listingSlice.reducer,
        notification:notificationSlice.reducer,
        locationProfile:LocationProfileSlice.reducer,
    }
})

export const useAppDispatch:()=> typeof store.dispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<ReturnType<typeof store.getState>> = useSelector;